// extracted by mini-css-extract-plugin
module.exports = {"categories":"Categories_categories__0acQs","name":"Categories_name__bZM04"};